import { IAddCheckItemTemplate } from '../../models/forms/ICheckItemTemplate';

export const AddCheckItemTemplateInitialState: IAddCheckItemTemplate = {
    Id: -1,
    CheckItemName: '',
    ProcessId: -1,
    Remarks: '',
    Headers: [],
    TenantId: 0,
};

export default AddCheckItemTemplateInitialState;
